<div
  id="leafletMap"
  *ngIf="show"
  leaflet
  style="height: 400px; border-radius: 16px; direction: ltr;"
  leafletDraw
  [leafletOptions]="options"
  [leafletDrawOptions]="drawOptions"
  [leafletDrawLocal]="drawLocal"
  [leafletLayers]="layers"
  (leafletDrawCreated)="onDrawCreated($event)"
  (leafletDrawStart)="onDrawStart($event)"
  (leafletDrawEditStop)="onEditStop($event)"
  (leafletDrawEditVertex)="onEditVertex()"
  (leafletDrawStop)="onDrawStop($event)"
  (leafletMapReady)="onMapReady($event)"
  (leafletMapZoomEnd)="onLeafletMapZoomEnd($event)"
  (leafletDrawDeleteStop)="onDeleteStop()"
  (leafletDrawEditStart)="onDrawEditStart($event)"
>
  <div [leafletLayer]="drawnItems"></div>
</div>
